import { useState } from "react";
import { CommonType } from "../../../types";

export const useParserConfigFormState = () => {
  const [parserName, setParserName] = useState("");
  const [description, setDescription] = useState("");
  const [connectionTypes, setConnectionTypes] = useState<CommonType[]>([]);
  const [selectedConnectionType, setSelectedConnectionType] = useState<CommonType | null>(null);
  const [payloadTypes, setPayloadTypes] = useState<CommonType[]>([]);
  const [selectedPayloadType, setSelectedPayloadType] = useState<CommonType | null>(null);

  const resetForm = () => {
    setParserName("");
    setDescription("");
    setSelectedConnectionType(null);
    setSelectedPayloadType(null);
  };

  return {
    parserName, setParserName,
    description, setDescription,
    connectionTypes, setConnectionTypes,
    selectedConnectionType, setSelectedConnectionType,
    payloadTypes, setPayloadTypes,
    selectedPayloadType, setSelectedPayloadType,
    resetForm,
  };
};
